import React, { useState, useEffect } from 'react';
import { API_URL } from '../services/api';
import {
  Grid,
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Chip,
  Avatar,
  useMediaQuery,
  useTheme
} from '@mui/material';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import axios from 'axios';

interface Program {
 id: number;
 name: string;
 description: string;
 dj_name: string;
 dj_photo: string;
 day_of_week: string;
 start_time: string;
 end_time: string;
}

const DAYS = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

const Programacion: React.FC = () => {
 const [selectedDay, setSelectedDay] = useState(0);
 const [programs, setPrograms] = useState<Program[]>([]);
 const theme = useTheme();
 const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

 useEffect(() => {
 const today = new Date().getDay();
 const dayIndex = today === 0 ? 6 : today - 1;
 setSelectedDay(dayIndex);
 fetchProgramsByDay(DAYS[dayIndex]);
 }, []);

 const fetchProgramsByDay = async (day: string) => {
 try {
 const response = await axios.get(`${API_URL}/api/programs/by-day/${day}`);
 setPrograms(response.data);
 } catch (error) {
 console.error('Error fetching programs:', error);
 }
 };

 const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
 setSelectedDay(newValue);
 fetchProgramsByDay(DAYS[newValue]);
 };

 const formatTime = (time: string) => {
 return time.slice(0, 5);
 };

 return (
 <Container maxWidth="lg" sx={{ mt: 4 }}>
 <Typography
 variant="h2"
 sx={{
 textAlign: 'center',
 mb: 2,
 fontWeight: 700,
 letterSpacing: '0.1em'}}
 >
 PROGRAMACIÓN
 </Typography>

 <Typography
 variant="h5"
 sx={{
 textAlign: 'center',
 mb: 4,
 opacity: 0.8,
 fontWeight: 300}}
 >
 Nuestra parrilla semanal
 </Typography>

 <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
 <Tabs
 value={selectedDay}
 onChange={handleTabChange}
 variant="scrollable"
 scrollButtons="auto"
 centered
 sx={{
 '& .MuiTab-root': {
 fontWeight: 600,
 letterSpacing: '0.05em',
 fontSize: '1.1rem'}}}
 >
 {DAYS.map((day) => (
 <Tab key={day} label={day} />
 ))}
 </Tabs>
 </Box>

 {programs.length === 0 ? (
 <Box sx={{ textAlign: 'center', py: 8 }}>
 <Typography variant="h6" color="text.secondary">
 No hay programas para este día
 </Typography>
 </Box>
 ) : (
 <Grid container spacing={3}>
 {programs.map((program) => (
 <Grid item xs={12} md={6} key={program.id}>
 <Card
 sx={{
 height: '100%',
 background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
 transition: 'transform 0.3s',
 '&:hover': {
 transform: 'translateY(-5px)'}}}
 >
 <CardContent>
 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
 <AccessTimeIcon sx={{ mr: 1, color: 'primary.main' }} />
 <Typography variant="h6" sx={{ fontWeight: 700 }}>
 {formatTime(program.start_time)} - {formatTime(program.end_time)}
 </Typography>
 </Box>

 <Typography
 variant="h5"
 sx={{
 mb: 2,
 fontWeight: 600,
 letterSpacing: '0.05em'}}
 >
 {program.name}
 </Typography>

 {program.description && (
 <Typography
 variant="body1"
 sx={{ mb: 2, opacity: 0.9 }}
 >
 {program.description}
 </Typography>
 )}

 {program.dj_name && (
 <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
 {program.dj_photo ? (
 <Avatar
 src={`${API_URL}${program.dj_photo}`}
 sx={{ mr: 2, width: 40, height: 40 }}
 />
 ) : (
 <Avatar sx={{ mr: 2, width: 40, height: 40, bgcolor: 'primary.main' }}>
 <PersonIcon />
 </Avatar>
 )}
 <Chip
 label={program.dj_name}
 color="primary"
 variant="outlined"
 icon={<PersonIcon />}
 />
 </Box>
 )}
 </CardContent>
 </Card>
 </Grid>
 ))}
 </Grid>
 )}

 </Container>
 );
};

export default Programacion;